import React, { Component } from 'react';
import { isLoggedIn, fetchSignedMessage, businessIdHeader, httpOKsuccess, postMethod, cssFormInputLabel, textField, cssFormInput, cssFormInputText, cssError, cssFormInputButton, cssFormCheckBox, checkBox, numberField, buttonType, emailRegularExpression, httpNotFound, emailAddressLength, emailIssueHeader, roleMerchant } from './Library'
import DualBallSpinner from '../img/dual-ball-1s-100px.gif';
import ReactDOM from 'react-dom';
import { NavMenu } from './NavMenu';

const divForFeedbackMessage = "responseMessageId";

export class AddExistingUserToBusiness extends Component {
	constructor(props) {
		super(props)
		this.state = {
			countrys: [],
			franchiseBusiness: false,
			users: [{emailAddress:'', emailAddressError: ''}],
			loading: true,
			sumbitButtonDisabled: false,
			validated: true
		};
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	async componentDidMount() {
		await isLoggedIn();
		this.setState({ loading: false });
	}


	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.type === 'number' ? parseInt(target.value) : target.value;
		const name = target.name;

		this.setState({
			[name]: value
	});
	}


	handleSubmit = async (event) => {

		event.preventDefault();
		let validated = true;

		for (let i = 0; i < this.state.users.length; i++) {
			if (!this.handleUserValidation(this.state.users[i])) {
				validated = false;
				this.setState({validated: false})
			}
		}
		
		if(validated) {
			var responseLabel = document.getElementById(divForFeedbackMessage);

			this.setState({ loading: true, sumbitButtonDisabled: true });
			var emailAddresses = [];

			for (let i = 0; i < this.state.users.length; i++) {
				const user = this.state.users[i];
				user.role = roleMerchant;
				emailAddresses.push(user.emailAddress);
			}

			try {

				const response = await fetchSignedMessage(JSON.stringify(emailAddresses), 'business/' + JSON.parse(sessionStorage.getItem(businessIdHeader)) + '/addusers', postMethod);

				var notFoundEmails = '';

				if (response.headers.has(emailIssueHeader)) {
					notFoundEmails = " The following email addresses weren't found in the system: " + response.headers.get(emailIssueHeader);
				}

				if (response.status == httpOKsuccess) {
					ReactDOM.render(<label className={cssFormInputLabel}>User(s) added to business succesfully.{notFoundEmails}</label>, responseLabel);
					this.setState({ loading: false, sumbitButtonDisabled: false });
				} else if (response.status == httpNotFound) {
					ReactDOM.render(<p className={cssError}>Email address was not found. Please check the address and try again.</p>, responseLabel);
					this.setState({ loading: false, sumbitButtonDisabled: false });
				} else {
					ReactDOM.render(<p className={cssError}>User adding to business failed. Please try again later.</p>, responseLabel);
					this.setState({ loading: false, sumbitButtonDisabled: false });
				}
			}
			catch (error) {
				this.setState({ loading: false, sumbitButtonDisabled: false });
				ReactDOM.render(<p className={cssError}>User adding to business failed. Please try again later.</p>, responseLabel)
			}
		}
	}

	handleAddUser = () => {
		this.setState({
			users: this.state.users.concat(
				[{ emailAddress: '', emailAddressError: '' }]
			)
		})
	}

	handleUserChange = (elementIndex) => (event) => {
		let users = this.state.users.map((item, i) => {
			if (elementIndex !== i) return item
			return { ...item, [event.target.name]: event.target.type === numberField ? Number(event.target.value) : event.target.value }
		});

		this.setState({ users });
	}

	handleRemoveUser = (elementIndex) => (event) => {
		this.setState({
			users: this.state.users.filter((item, i) => {
				return elementIndex != i
			})
		})
	}


	handleUserValidation(item) {
		let validated = true;

		if (item.emailAddress.length == 0) {
			item.emailAddressError = "A user requires an email address";
			validated = false;
		} else {
			if (emailRegularExpression.test(item.emailAddress)) {
				item.emailAddressError = "";
			} else {
				validated = false;
				item.emailAddressError = "Email address is not formatted correctly"
			}
		}

		return validated;
	}


	handleValidation() {
		let validated = true;

		if (this.state.emailAddress.length == 0) {
			this.setState({emailAddressError: "A user requires an email address"});
			validated = false;
		} else {
			if (emailRegularExpression.test(this.state.emailAddress)) {
				this.setState({emailAddressError: ""});
			} else {
				validated = false;
				this.setState({ emailAddressError: "Email address is not formatted correctly" });
			}
		}
		return validated;
	}

	user(i, item) {
		return <>
			<label className={cssFormInputLabel}>
				Email Address:
				<input type={textField} name="emailAddress" onChange={this.handleUserChange(i)} className={cssFormInputText} value={item.emailAddress} maxLength={emailAddressLength} /><br />
			</label>{item.emailAddressError && <p className={cssError} >{item.emailAddressError}</p>}
			{this.state.franchiseBusiness && <div><label className={cssFormInputLabel}><input type={checkBox} className={cssFormCheckBox} name="franchisor" onChange={this.handleUserChange(i)} />Franchisor</label></div>}
			<div><button type={buttonType} className={cssFormInputButton} onClick={this.handleRemoveUser(i)}>Delete</button></div></>
	}

	render() {
		return (<>
			<NavMenu />
			<form onSubmit={this.handleSubmit} className={cssFormInput}>

				{this.state.users.map((item, i) => (
					this.user(i, item)
				))}
				<button type={buttonType} className={cssFormInputButton} onClick={this.handleAddUser}>Add User</button>

				<input type="submit" value="Add User to Business" className={cssFormInputButton} disabled={this.state.sumbitButtonDisabled} />
			</form>
				{ this.state.loading ? <img src={DualBallSpinner} alt="Loading" /> : '' }
			<div id={divForFeedbackMessage} />
		</>
		);
	}
}
